import { useState, useRef, useEffect } from 'react';
import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { MediumDataKey } from 'modules/templateEditor/common/types';
import { CopyAssistTagNames } from 'modules/domains/copyAssist/copyAssist';
import {
  StyledCopyAssistButton,
  StyledGenerateAiIcon,
  StyledCopyAssistButtonText,
  StyledBtnWrapper,
  ICON_SIZE_28,
  TEXTAREA_FIELD_CSS_RIGHT,
  INPUT_FIELD_CSS_RIGHT,
} from 'modules/ai/copyAssist/components/styles';
import { pxToRem } from 'utils/convert';

interface CopyAssistMenuBtnProps {
  mediumDataKey?: MediumDataKey;
  /** ref for the element to target */
  targetRef?: React.RefObject<HTMLDivElement> | null;
  onClick?: (e: any) => void;
  targetTagName: CopyAssistTagNames;
}

export const CopyAssistButton = ({ targetRef, onClick, targetTagName }: CopyAssistMenuBtnProps) => {
  const copyAssistButtonTextEl = useRef<HTMLDivElement>(null);
  const [hoveredButtonTextMaxWidth, setHoveredButtonTextMaxWidth] = useState(0);
  const [hoveredButtonTargetTop, setHoveredButtonTargetTop] = useState(0);

  useEffect(() => {
    const width =
      copyAssistButtonTextEl && copyAssistButtonTextEl.current
        ? copyAssistButtonTextEl.current?.getBoundingClientRect().width
        : 0;
    setHoveredButtonTextMaxWidth(width + ICON_SIZE_28 + 5);
    const height =
      targetRef && targetRef.current ? targetRef.current?.getBoundingClientRect().height : 0;
    setHoveredButtonTargetTop(height);
  }, []);

  let cssRight = 0;
  if (targetTagName === CopyAssistTagNames.Input) {
    cssRight = INPUT_FIELD_CSS_RIGHT;
  } else if (
    targetTagName === CopyAssistTagNames.TextArea ||
    targetTagName === CopyAssistTagNames.WhatsAppTextArea ||
    targetTagName === CopyAssistTagNames.InputWithNoTriggerIcon
  ) {
    cssRight = TEXTAREA_FIELD_CSS_RIGHT;
  }

  const cssTop = CopyAssistTagNames.WhatsAppTextArea
    ? hoveredButtonTargetTop - ICON_SIZE_28 - 10
    : hoveredButtonTargetTop - ICON_SIZE_28 / 2;

  return (
    <StyledCopyAssistButton
      data-test="copy-assist-button"
      onClick={onClick}
      style={{ top: `${pxToRem(cssTop)}`, right: `${pxToRem(cssRight)}` }}
    >
      <StyledBtnWrapper data-text-max-width={hoveredButtonTextMaxWidth}>
        <StyledGenerateAiIcon>
          <AiSparkle16 />
        </StyledGenerateAiIcon>
        <StyledCopyAssistButtonText
          ref={copyAssistButtonTextEl}
          id="copy-assist-button-text"
        >{`Iterate`}</StyledCopyAssistButtonText>
      </StyledBtnWrapper>
    </StyledCopyAssistButton>
  );
};
